/**
 * SPA Navigation Utility
 * Allows non-React components (like Axios interceptors or API service classes)
 * to perform navigation using React Router's navigate function without a full page reload.
 */

type NavigateFunction = (path: string, options?: { replace?: boolean }) => void;

let navigateFn: NavigateFunction = (path: string) => {
  // Fallback to window.location if navigateFn hasn't been set yet
  window.location.href = path;
};

/**
 * Register the React Router navigate function.
 * This should be called once from a component within a BrowserRouter.
 */
export const setNavigate = (fn: NavigateFunction) => {
  navigateFn = fn;
};

/**
 * Perform SPA-safe navigation.
 */
export const navigate = (path: string, options?: { replace?: boolean }) => {
  navigateFn(path, options);
};
